import { useAtomValue } from 'jotai';
import { competitionsAtom } from '@/atoms/queries/competitions';
import { rawCyclesAtom } from '@/atoms/queries/cycles';
import { eventNamesAtom } from '@/atoms/queries/eventData';
import { metricDefinitionsAtom } from '@/atoms/queries/metric';
import { playerIdMappingAtom, playersAtom } from '@/atoms/queries/players';
import { seasonsAtom } from '@/atoms/queries/seasons';
import { teamIdMappingAtom, teamsAtom, userDefaultTeamIdsAtom } from '@/atoms/queries/teams';
import { hudlUserIdUserNameMapAtom } from '@/atoms/queries/user';
import { loadable } from '@/utils/jotai';

/**
 * This hook can be used to ensure that we eagerly fetch reference data required
 * across the entire application. Doing this means that time to load pages within
 * the application is reduced as the data required has already been fetched and
 * cached.
 */
export const useApplicationReferenceData = () => {
  useAtomValue(loadable(competitionsAtom));
  useAtomValue(loadable(seasonsAtom));
  useAtomValue(loadable(rawCyclesAtom));
  useAtomValue(loadable(teamsAtom));
  useAtomValue(loadable(playersAtom));
  useAtomValue(loadable(eventNamesAtom));
  useAtomValue(loadable(metricDefinitionsAtom));
  useAtomValue(loadable(hudlUserIdUserNameMapAtom));
  useAtomValue(loadable(playerIdMappingAtom));
  useAtomValue(loadable(teamIdMappingAtom));
  useAtomValue(loadable(userDefaultTeamIdsAtom));
};
